import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";

let ready = false;

export function initMetaPixel(pixelId) {
  if (ready || !pixelId || typeof window === "undefined") return;
  if (!window.fbq) {
    const fbq = function () { fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments); };
    fbq.push = fbq; fbq.loaded = true; fbq.version = "2.0"; fbq.queue = [];
    window.fbq = fbq; window._fbq = fbq;
    const s = document.createElement("script"); s.async = true; s.src = "https://connect.facebook.net/en_US/fbevents.js"; s.setAttribute("data-testid", "meta-pixel-script");
    document.head.appendChild(s);
  }
  window.fbq("init", pixelId);
  window.fbq("track", "PageView");
  ready = true;
}

export function track(name, params = {}, eventId) {
  if (!ready || !window.fbq) return null;
  const id = eventId || `${name.toLowerCase()}:${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  window.fbq("track", name, params, { eventID: id });
  return id;
}

// Mounted once inside the public SiteLayout: loads pixel + virtual PageViews on route change.
export function MetaPixel() {
  const { settings } = useSettings();
  const { pathname } = useLocation();
  const id = settings?.meta_pixel_enabled ? settings.meta_pixel_id : "";
  useEffect(() => { if (id) initMetaPixel(id); }, [id]);
  useEffect(() => { if (ready && pathname) window.fbq?.("track", "PageView"); }, [pathname]);
  return null;
}
